import React from 'react';
import { useTheme } from 'styled-components/macro';
import { Tooltip } from '../../atoms';
import { IconI, IconWrapper } from '../../icons';
import { SPACINGS } from '../../utils';
import MobileTooltip, {
  MobileTooltipProps,
} from '../../atoms/MobileTooltip/MobileTooltip';
import { TooltipProps } from '../../atoms/Tooltip/Tooltip';

type InfoTooltipProps =
  | ({ type: 'mobile'; iconStyle?: React.CSSProperties } & Omit<
      MobileTooltipProps,
      'children'
    >)
  | ({ type: 'desktop'; iconStyle?: React.CSSProperties } & Omit<
      TooltipProps,
      'children'
    >);

const containerStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: SPACINGS[1],
};

function InfoTooltip(props: InfoTooltipProps) {
  const theme = useTheme();

  if (props.type === 'desktop' || !props.type) {
    const { type, iconStyle, ...rest } = props;
    const containerStyleFromProps = rest.containerStyle ?? {};

    return (
      <Tooltip
        {...rest}
        containerStyle={{ ...containerStyle, ...containerStyleFromProps }}
      >
        <IconWrapper
          type="action"
          style={{ border: `2px solid ${theme.colors.primary}` }}
        >
          <IconI stroke={theme.colors.primary20b} />
        </IconWrapper>
      </Tooltip>
    );
  }

  if (props.type === 'mobile') {
    const { type, iconStyle, ...rest } = props;

    return (
      <MobileTooltip {...rest}>
        <IconWrapper
          type="action"
          style={{
            border: `1px solid ${theme.colors.primary20b}`,
            minWidth: SPACINGS[8],
            minHeight: SPACINGS[8],
            backgroundColor: 'transparent',
            ...iconStyle,
          }}
        >
          <IconI stroke={theme.colors.primary20b} />
        </IconWrapper>
      </MobileTooltip>
    );
  }

  return null;
}

export default InfoTooltip;
